import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "../lib/consent";
import { trackPageview, updateAnalyticsConsent } from "../lib/analytics";

export function Analytics() {
  const consent = useConsent();
  const location = useLocation();
  const consentSyncedRef = useRef(false);

  useEffect(() => {
    updateAnalyticsConsent(consent?.analytics === true);
    consentSyncedRef.current = true;
  }, [consent?.analytics]);

  useEffect(() => {
    if (!consentSyncedRef.current) return;
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
